import type { Prototype } from "../prototype-types";

export const pedroAlvesPrototypes: Prototype[] = [
  {
    id: "pa-brand-page-bestseller-ranking",
    name: "Brand Page Bestseller Ranking",
    path: "/pa/brand-page-bestseller-ranking",
    description:
      "Brand page exploring guidepost badges: numbered #N Bestseller on the Bestsellers tab (ordered #1-first vs preserved order where #1 isn't necessarily first), plus scattered New / Previously ordered guideposts on the other tabs.",
    owner: "Pedro Alves",
    createdAt: "2026-07-29",
    lastUpdated: "2026-07-29",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c022c0f5b35ffbcf2ef7744f2e439a92b5531f8c6228b4b6b0656e2697105d3d.png",
    creationTool: "claude-code",
  },
  {
    id: "pa-brand-page-new-tab-date-groups",
    name: "Brand Page New Tab Date Groups",
    path: "/pa/brand-page-new-tab-date-groups",
    description:
      "New tab splits purchasable products into This week / Last 2 weeks / Earlier this month using first_purchasable_at, with a this-week count on the tab.",
    owner: "Pedro Alves",
    createdAt: "2026-08-31",
    lastUpdated: "2026-10-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1ff4997e4a0c6ce955e06aa8ea44a78f0ef5d3a37f36e09c88f5501ee39ba068.png",
    figmaLink:
      "https://www.figma.com/design/W8xlMBlQtF0DOBNG24xEff/BP--Category-navigation?node-id=11003-32257",
  },
];
